import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './avisos_privacidad.css';
import { avisos_privacidad_item } from '../../json/avisos_privacidad';

const Avisos_Privacidad = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container avisos_privacidad-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='avisos_privacidad_title'>
                    <h1>Avisos de Privacidad</h1>
                </div>
            </div>
        </div>
        <div className='row'>
            {
                avisos_privacidad_item.map((item, index)=>(
                    <div key={ index } className='col-md-4 col-sm-6 col-12 avisos_privacidad_item'>
                        <Link target='_black' to={ item.avisos_privacidad_item_url }><b>{ item.avisos_privacidad_item_titulo }</b> </Link>{ item.avisos_privacidad_item_nombre }
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default Avisos_Privacidad